<script>
    import { onMount, createEventDispatcher } from "svelte";
    import { fly, fade } from "svelte/transition";
    import { XIcon, ShoppingCartIcon } from "svelte-feather-icons";
    import LoadingMask from "./LoadingMask.svelte";
    import Quantity from "./Cart/Quantity.svelte";

    export let bundleId;

    let mask;
    let isLoading = false;
    let cartItems = [];

    if (!window.digi_object) {
        window.digi_object = {};
        window.digi_object.bundle_url =
            "http://digibordshop.local/wp-json/bundle/v1";
        window.digi_object.site_url = "http://digibordshop.local/";
    }

    onMount(async () => {
        document.body.classList.toggle("modal-is-open");

        await refreshCart();
    });

    async function refreshCart() {
        isLoading = true;
        console.log("loading...");
        const cartResponse = await fetchCart();
        cartItems = await cartResponse.items;

        isLoading = false;

        console.log("done...", { cartItems });
    }

    async function fetchCart() {
        const itemsRequest = await fetch(digi_object.bundle_url + "/products", {
            cache: "no-cache",
        });
        const cartObject = await itemsRequest.json();

        console.log(itemsRequest);

        return {
            items: Object.entries(cartObject).map((entries) => {
                return entries[1];
            }),
        };
    }

    const dispatch = createEventDispatcher();

    function handleMaskClick(e) {
        if (e.target === mask) {
            dispatch("close");
        }
    }
</script>

<div
    class="modal-mask"
    transition:fade={{ duration: 250 }}
    bind:this={mask}
    on:click|stopPropagation={handleMaskClick}
>
    <div class="inner">
        <div class="inner__title">
            <h2>Uw product is toegevoegd aan de winkelwagen</h2>
            <button type="button" on:click={() => dispatch("close")}>
                <XIcon />
            </button>
        </div>

        <div class="inner__body">
            <LoadingMask loading={isLoading} />
            <p>
                <strong>Kortingsactie</strong>: Bijpassend ErgoXS onderstel ter
                waarde van 650,- <br />
                nu voor slechts 450,-!
            </p>
            <p class="image"><a href={cartItems[2]}>{@html cartItems[1]}</a></p>
            <h2><a href={cartItems[2]}>{cartItems[3]}</a></h2>
            <p class="price">Prijs: &euro; {cartItems[4]}</p>
            <p>
                <a
                    href={cartItems[2]}
                    rel="nofollow"
                    data-product_title={cartItems[3]}
                    data-product_id={cartItems[0]}
                    data-quantity="1"
                    class="button alt single_add_to_cart_button"
                    >Nu bestellen!</a
                >
                <a
                    href=""
                    on:click={() => dispatch("close")}
                    class="button further">Verder winkelen</a
                >
            </p>
        </div>
    </div>
</div>

<style lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9999999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        margin: auto;
        justify-content: center;
        align-items: center;
    }

    .inner {
        width: 550px;
        background: #fff;
        position: fixed;
        right: 50%;
        left: 40%;
        top: 30%;
        height: 550px;
        border-radius: 10px;

        &__title {
            height: 50px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 15px;
            padding-right: 15px;
            border-bottom: 1px solid rgba(128, 128, 128, 0.2);

            h2 {
                font-size: 19px;
                font-weight: 700;
                color: #0d78b7;
                line-height: 27px;
                margin-bottom: 0;
            }

            button {
                width: 24px;
                height: 24px;
                background: transparent;
                border: none;
                color: #000;
                display: flex;
                padding: 0;
                align-items: center;
                justify-content: center;

                :global(svg) {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        &__body {
            position: relative;
            padding: 20px;

            & p {
                text-align: center;

                &.price {
                    font-size: 18px;
                    font-weight: 700;
                    color: #2f2f2f;
                }

                &.image {
                    width: 200px;
                    margin: 0 auto 20px;
                }

                & a.button {
                    background-color: #26cb01 !important;
                    width: 190px;

                    &.further {
                        border: 2px solid #6ac1e4 !important;
                        color: #6ac1e4 !important;
                        background-color: transparent !important;
                        padding: 0.8rem 2rem 0.8rem;
                    }
                }
            }

            h2 {
                font-size: 22px;
                font-weight: 700;
                color: #0d78b7;
                line-height: 27px;
                margin-bottom: 1rem;
                text-align: center;

                & a {
                    color: #0d78b7;
                    text-decoration: none;
                }
            }
        }

        &__footer {
            border-top: 1px solid rgba(128, 128, 128, 0.2);
            padding-left: 15px;
            padding-right: 15px;
            padding-top: 10px;
            padding-bottom: 10px;

            position: absolute;
            bottom: 0;
            width: 100%;
        }

        &__checkout {
            button {
                display: block;
                margin-top: 10px;
                text-transform: lowercase;
                letter-spacing: normal;
                margin-right: 15px;
            }

            .button--orange {
                background-color: #fabe00 !important;
            }

            &-lease {
                display: flex;
                align-items: flex-end;

                > div {
                    width: 100%;
                    margin-left: 5px;
                }

                p {
                    margin-bottom: 0;
                    font-size: 12px;
                }

                select {
                    padding: 5px;
                    width: 100%;
                }
            }
        }

        &__product {
            display: flex;
            padding: 10px 15px;

            &-image {
                flex: 0 0 100px;

                img {
                    width: 80px;
                    height: 80px;
                    object-fit: contain;
                }
            }

            &-info {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-content: center;
                position: relative;
            }

            &-title {
                line-height: 1.2;
                font-weight: 700;
                font-size: 16px;
                width: 100%;
                align-items: center;
                color: #1483c5;
                margin-bottom: 10px;
            }

            &-price {
                display: block;
                font-size: 18px;
                font-weight: 700;
                color: #2f2f2f;
                margin-bottom: 0;
                width: 100%;
            }

            &-price.no-tax {
                font-weight: 400;
                font-size: 14px;
                color: #25cb01;
            }

            &-close {
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                padding: 0;
                width: 24px;
                height: 24px;
                background: transparent;

                :global(svg) {
                    width: 24px;
                    height: 24px;
                    stroke: red;
                }
            }

            &-footer {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
            }
        }
    }

    @media (max-width: 991.98px) {
        .modal-mask {
            width: 100vw;
        }

        .cart {
            width: 100%;
            right: unset;
            top: unset;
            display: flex;
            flex-flow: column;

            &__title {
                height: 75px;
            }

            &__body {
                overflow: auto;
                height: 100%;
            }

            &__footer {
                position: relative;
            }
        }
    }

    /*// Extra small devices (portrait phones, less than 576px)*/
    /*@media (max-width: 575.98px) { ... }*/

    /*// Small devices (landscape phones, less than 768px)*/
    /*@media (max-width: 767.98px) { ... }*/

    // Medium devices (tablets, less than 992px)

    // Large devices (desktops, less than 1200px)
    /*@media (max-width: 1199.98px) { ... }*/
</style>
